module.exports = __webpack_public_path__ + "static/img_4305-dd9751c9a0dfd30ed839cd86281a1aec.webp";